import axios from 'axios';
import Cookie from 'js-cookie'
const request = axios.create({
    baseURL:'//pay.iciba.com',
    method:'get',
    // `transformRequest` 允许在向服务器发送前，修改请求数据
    // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
    // 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
    transformRequest: [function (data) {
        // 对 data 进行任意转换处理
        return data;
    }],
    // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
    transformResponse: [function (data) {
        // 对 data 进行任意转换处理
        return data;
    }],
    // 设置默认请求头
    headers:{
        'Content-type':'application/x-www-form-urlencoded',
        'Authorization':Cookie.get('Authorization'),
    },
    timeout: 10000,
    responseType: 'json', // 设置默认返回数据格式为json
})
// 定义请求实例拦截器
request.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
request.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response.data
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default request;